import { api } from '../api';

// Action Types

export const Types = {
  SETWORKFLOWDATA: 'set/workflow/data',
};

// Reducer

const initialState = {
  workflowId: null,
  workflowData: null,
  open: false,
  isFinished: false,
  workflowList: [],
  workflowIncompleteList: [],
  saveData: null,
  confirmDialog: false,

};

export default (state = initialState, action) => {

  switch (action.type) {
    case Types.SETWORKFLOWDATA:
      return { ...state, ...action.result };
    default:
      return state;
  }

};

// Action Creators

export const setWorkflowData = params => ({
  type: Types.SETWORKFLOWDATA,
  result: params || initialState,
});



// WEBPACK FOOTER //
// ./src/redux/workflow.js